import { useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { AssistantChat } from "./AssistantChat";
import { useIsMobile } from "@/hooks/use-mobile";

export function AssistantBubble() {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  const { pathname } = useLocation();

  // The assistant is only meant as a quick-create shortcut from the
  // dashboard on desktop. On mobile we already have the in-header
  // create button, and on inner pages (card view, wizard, admin) the
  // bubble would just get in the way. Gate the render here so the
  // bubble disappears everywhere except /dashboard on desktop.
  if (isMobile) return null;
  if (pathname !== "/dashboard") return null;

  return (
    <>
      {/* Chat Panel */}
      {open && (
        <div className="fixed bottom-24 right-5 z-50 w-[380px] h-[560px] rounded-2xl overflow-hidden">
          <AssistantChat onClose={() => setOpen(false)} />
        </div>
      )}

      {/* Floating Bubble */}
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-lg hover:shadow-xl hover:scale-105 transition-all flex items-center justify-center"
          aria-label="Open card assistant"
        >
          <MessageCircle size={24} />
        </button>
      )}
    </>
  );
}
